import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import h5Router from '@/router/modules/h5';
import { setWebPageTitle } from "@/utils/nativebridge";

//NProgress.configure({ showSpinner: false }) // NProgress Configuration

var whiteList = ['/login', '/auth-redirect', '/quicklogin', '/loginedu']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var url, hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          //特殊页面 隐藏面包屑组件
          url = ['/gov/healthily/provinceana', '/gov/healthily/cityana', '/gov/healthily/districtana', '/gov/healthily/province', '/gov/healthily/city', '/gov/healthily/district', '/gov/healthily-work/gyinform', '/gov/healthily-work/sub', '/gov/healthily-work/inform', '/gov/healthily-work/ques', '/gov/healthily-work/sight'];
          if (to.path.indexOf("workbench") !== -1 || url.find(function (item) {
            return item == to.path;
          })) {
            store.dispatch('app/setBreadcrumb', false);
          } else if (to.matched[0]) {
            if (to.matched[0].name) {
              if (to.matched[0].name.indexOf("datareport") !== -1 || to.matched[0].name.indexOf("datavision") !== -1) {
                store.dispatch('app/setBreadcrumb', false);
              } else {
                store.dispatch('app/setBreadcrumb', true);
              }
            } else {
              store.dispatch('app/setBreadcrumb', true);
            }
          } else {
            store.dispatch('app/setBreadcrumb', true);
          }
          console.log('to.path', to.path);
          if (to.path.indexOf("indexvision") !== -1) {
            store.dispatch('app/setBreadcrumb', false);
          } else if (to.path.indexOf("indexillness") !== -1) {
            store.dispatch('app/setBreadcrumb', false);
          }

          // 判断是否为数据分析页面或者数据可视化页面
          if (to.matched[0] && to.matched[0].name && (to.matched[0].name.indexOf("datareport") !== -1 || to.matched[0].name.indexOf("datavision") !== -1) || url.find(function (item) {
            return item == to.path;
          })) {
            store.dispatch('app/setDataAnalysis', true);
          } else {
            store.dispatch('app/setDataAnalysis', false);
          }
          // start progress bar
          //NProgress.start()

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 37;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 11;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          //NProgress.done()
          _context.next = 35;
          break;
        case 11:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 16;
            break;
          }
          next();
          _context.next = 35;
          break;
        case 16:
          _context.prev = 16;
          _context.next = 19;
          return store.dispatch('user/getInfo');
        case 19:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          _context.next = 23;
          return store.dispatch('permission/generateRoutes', roles);
        case 23:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record

          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          if (from.path == '/login' || from.path == '/loginedu') {
            if (roles == "superadmin" || roles == "superadmin_03") {
              next({
                path: '/workbenchnationwide'
              });
            }
            if (roles == "province" || roles == "province_03") {
              next({
                path: '/workbench'
              });
            }
            if (roles == "city" || roles == "city_03") {
              next({
                path: '/workbench'
              });
            }
            if (roles == "district" || roles == "district_03") {
              next({
                path: '/workbench'
              });
            }
            if (roles == "screen" || roles == "screen_03") {
              next({
                path: '/workbenchscreen'
              });
            }
            if (roles == "schooldoctor") {
              next({
                path: '/workbenchschool'
              });
            }
            if (roles == "schooladmin") {
              next({
                path: '/workbenchschool'
              });
            }
            if (roles == "schoolclazz") {
              next({
                path: '/workbenchgarde'
              });
            }
            if (roles == "schoolgrade") {
              next({
                path: '/workbenchgarde'
              });
            }
          }
          _context.next = 35;
          break;
        case 29:
          _context.prev = 29;
          _context.t0 = _context["catch"](16);
          _context.next = 33;
          return store.dispatch('user/resetToken');
        case 33:
          Message.error(_context.t0 || 'Has Error');
          if (sessionStorage.getItem('login-from') == 'quicklogin') {
            next("/quicklogin");
          } else if (sessionStorage.getItem('login-from') == 'loginedu') {
            next("/loginedu");
          } else {
            next("/login?redirect=".concat(to.path));
          }

          //NProgress.done()
        case 35:
          _context.next = 38;
          break;
        case 37:
          //h5页面
          if (h5Router.some(function (role) {
            return to.path == role.path;
          })) {
            if (to.meta) {
              document.title = to.meta.title;
              setWebPageTitle(to.meta.title);
            }
            next();
            //白名单页面
          } else if (whiteList.indexOf(to.path) !== -1) {
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            if (sessionStorage.getItem('login-from') == 'quicklogin') {
              next("/quicklogin");
            } else if (sessionStorage.getItem('login-from') == 'loginedu') {
              next("/loginedu");
            } else {
              next("/login?redirect=".concat(to.path));
            }
            //NProgress.done()
          }
        case 38:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[16, 29]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  //NProgress.done()
});